const ru = {
  code: 'ru',
  short: 'RU',
  label: 'Русский',
  native: 'Русский',
  hero: {
    badge: 'Клининг • Братислава',
    title: 'Чистое пространство. Свежая голова.',
    lead: 'Надежная уборка квартир и офисов с прозрачными ценами и простой записью.',
    cta: 'Заказать',
    whatsapp: 'WhatsApp'
  },
  header: {
    home: 'Главная',
    services: 'Услуги',
    contact: 'Контакты',
    book: 'Заказать',
    whatsapp: 'WhatsApp',
    language: 'Язык'
  },
  home: {
    licensed: 'Лицензия • Страховка • Химия включена',
    firstCleanDiscountBadge: '10 %',
    firstCleanDiscount: 'Скидка на первую уборку',
    servicesTitle: 'Наши услуги',
    seeDetails: 'Подробнее →',
    whyTitle: 'Почему Sparklean?',
    reasons: [
      'Надёжная и проверенная команда специалистов',
      'Исполнители с рекомендациями и проверенным опытом',
      'Гибкие слоты, включая вечерние',
      'Фиксированные цены, без скрытых доплат'
    ],
    areaTitle: 'Работаем',
    areaCopy: 'Братислава и ближайшие районы.',
    quote: 'Получить предложение'
  },
  optional: 'необязательно',
  servicesPage: {
    title: 'Услуги',
    subtitle: 'Нажмите на карточку, чтобы открыть список работ, галерею и примечания по цене.'
  },
  notFound: {
    message: 'Страница не найдена.',
    back: 'На главную'
  },
  serviceDetail: {
    notFound: 'Услуга не найдена',
    back: 'Назад к услугам',
    bookThis: 'Заказать услугу',
    allServices: 'Все услуги'
  },
  contact: {
    title: 'Контакты',
    hours: 'Отвечаем Пн–Сб 8:00–20:00.',
    emailLabel: 'Email',
    phoneLabel: 'Телефон',
    whatsappAvailable: 'Доступны в WhatsApp',
    whatsapp: 'Написать в WhatsApp',
    email: 'Отправить email',
    office: 'Офис',
    address: 'Karpatské námestie 10A, Bratislava, Slovakia'
  },
  booking: {
    title: 'Бронирование',
    subtitle: 'Расскажите о помещении и времени. Подтвердим по email или WhatsApp.',
    fullName: 'Полное имя',
    fullNamePlaceholder: 'Анна Иванова',
    serviceField: 'Услуга',
    dateField: 'Предпочтительная дата',
    datePlaceholder: 'ДД-ММ-ГГГГ',
    timeField: 'Предпочтительное время',
    nameField: 'Имя',
    emailField: 'Email',
    phoneField: 'Телефон',
    phonePlaceholder: '+421 900 000 000',
    addressField: 'Адрес',
    addressPlaceholder: 'Улица, номер, район',
    notesField: 'Комментарий',
    notesPlaceholder: 'Животные, парковка, код ворот и т.д.',
    submit: 'Отправить заявку',
    chooseService: 'Выбрать услугу',
    pick: 'Выбрать',
    successTitle: 'Запрос отправлен ✅',
    successLine: 'Спасибо! Ваш номер:',
    successNote: 'Скоро подтвердим по email или в WhatsApp.',
    calendarMonth: 'long',
    pickerDescription: 'Выберите нужный тип уборки.',
    pickerTip: 'Подсказка: позже можно изменить.',
    whatsappAlt: 'или напишите нам в WhatsApp',
    privacy: 'Мы бережно храним данные. Отправляя форму, вы соглашаетесь на контакт по этой заявке.',
    error: 'Что-то пошло не так. Попробуйте снова.',
    errorTitle: 'Заявка не отправлена',
    errorMessage: 'Не удалось отправить заявку. Попробуйте ещё раз или свяжитесь с нами напрямую.',
    errorWhatsapp: 'Открыть чат WhatsApp',
    errorEmail: 'Написать на email',
    required: 'Обязательное поле',
    emailError: 'Введите корректный email',
    phoneError: 'Используйте цифры, +, пробел или тире',
    minChars: 'Минимум 10 символов',
    addressHint: 'Укажите улицу и номер дома',
    pickerTitle: 'Выберите услугу',
    calendarTitle: 'Выберите дату'
  },
  footer: {
    tagline: 'Профессиональный клининг в Братиславе и рядом.',
    rights: 'Все права защищены.',
    getInTouch: 'Связаться',
    chat: 'Написать в WhatsApp'
  },
  services: [
    {
      slug: 'regular-cleaning',
      title: 'Регулярная уборка',
      short: 'Поддержание чистоты ежедневно или еженедельно.',
      intro: 'Регулярная уборка сохраняет порядок и комфорт.',
      description: [
        'Тщательно пылесосим и моем все доступные поверхности, аккуратно убираем пыль, чистим кухню и санузел — дом остаётся свежим и опрятным.',
        'Рекомендуемая частота: каждую неделю, раз в две недели или раз в месяц.'
      ],
      bullets: [
        'Пылесосим и моем полы',
        'Стираем пыль с доступных поверхностей',
        'Дезинфицируем кухню и ванную',
        'Выносим мусор и меняем пакеты'
      ],
      priceNote: '18 € / час • Минимум 2 часа'
    },
    {
      slug: 'general-cleaning',
      title: 'Генеральная уборка',
      short: 'Баланс между регулярной и глубокой уборкой.',
      intro: 'Более детальная уборка, чем обычная поддержка.',
      description: [
        'Все шаги регулярной уборки плюс тщательная забота о кухне и ванной, внешние поверхности техники, внутренности духовки и холодильника, уход за зонами питомцев.',
        'Рекомендуемая частота: еженедельно, раз в две недели или раз в месяц.'
      ],
      bullets: [
        'Чек-лист регулярной уборки включен',
        'Детализация кухни и санузла',
        'Чистка духовки и холодильника внутри',
        'Удаление шерсти и уборка мест питомцев (кормление, лоток)'
      ],
      priceNote: '20 € / час • Минимум 2 часа'
    },
    {
      slug: 'deep-cleaning',
      title: 'Глубокая уборка',
      short: 'Полное очищение сверху донизу для максимальной свежести.',
      intro: 'Самая детальная услуга с акцентом на труднодоступные зоны и технику.',
      description: [
        'Включает каждый шаг генеральной уборки, плюс окна изнутри и снаружи (где достаем), внутреннюю чистку шкафов и глубокую обработку техники: холодильник, духовка, микроволновка.',
        'По запросу — уборка балкона. Рекомендуем, когда нужно полностью освежить дом.'
      ],
      bullets: [
        'Удаление известкового налета и жира',
        'Чистка шкафов и гардеробов внутри',
        'Окна изнутри и снаружи (доступные)',
        'Глубокая чистка техники'
      ],
      priceNote: '22 € / час • Минимум 2 часа'
    },
    {
      slug: 'post-construction-cleaning',
      title: 'Уборка после ремонта',
      short: 'Удаление пыли, краски и мусора после работ.',
      intro: 'Профессиональная уборка после ремонта или стройки.',
      description: [
        'Убираем пыль, клей, краску и мусор, моем окна, полы, поверхности и санузлы, чтобы помещение было готово к заселению — чистое и без пыли.'
      ],
      bullets: [
        'Удаление строительной пыли и остатков',
        'Детальная чистка фурнитуры, розеток и выключателей',
        'Мытьё окон, рам и подоконников',
        'Финальная полировка полов и поверхностей'
      ],
      priceNote: 'Индивидуальный расчёт после осмотра'
    },
    {
      slug: 'move-in-move-out',
      title: 'Уборка при переезде',
      short: 'Идеально перед заселением или сдачей жилья.',
      intro: 'Детальная уборка для безупречной передачи или въезда.',
      description: [
        'Сосредотачиваемся на шкафах, технике, плинтусах и фурнитуре, чтобы квартира была безупречной для владельца или новых жильцов.',
        'Отлично подходит перед съемкой, проверками или заселением.'
      ],
      bullets: [
        'Шкафы и ящики очищены внутри',
        'Обезжиренная техника внутри',
        'Протёртые окна и рамы',
        'Внимание к деталям: плинтусы, выключатели'
      ],
      priceNote: 'Фиксированное предложение после быстрой оценки'
    },
    {
      slug: 'office-cleaning',
      title: 'Уборка офисов',
      short: 'Держите рабочее место безупречным и продуктивным.',
      intro: 'Безупречный и организованный офис с профессиональной командой.',
      description: [
        'Глубоко очищаем все зоны — от рабочих мест и переговорных до кухонь и санузлов — создаём чистую и гигиеничную среду.',
        'Команда работает точно и деликатно, поддерживает профессиональный имидж и комфортную атмосферу для сотрудников и клиентов.'
      ],
      bullets: [
        'Рабочие зоны, переговорные, ресепшен',
        'Дезинфекция кухонь и санузлов',
        'Вынос мусора и сортировка',
        'Гибкие графики вне рабочего времени'
      ],
      priceNote: 'Цена по запросу'
    },
    {
      slug: 'commercial-cleaning',
      title: 'Коммерческая уборка',
      short: 'Профессиональный сервис для ресторанов, отелей и магазинов.',
      intro: 'Создайте безупречную атмосферу для гостей и команды.',
      description: [
        'Предоставляем качественный клининг для ресторанов, отелей, магазинов, салонов, фитнес-центров и офисов, чтобы каждая зона была чистой и гигиеничной.',
        'Внимание к деталям — блестящие полы и мебель, продезинфицированные кухни и санузлы. Используем экологичные средства и проверенные методы для безопасности и комфорта.',
        'Гибкие графики и персональные планы под ваш режим работы для минимальных пауз.'
      ],
      bullets: [
        'Фронт, бэк-офис и складские зоны',
        'Дезинфекция зон частого касания',
        'Уход за твёрдыми полами и коврами',
        'Планы под каждый тип бизнеса'
      ],
      priceNote: 'Цена по запросу'
    },
    {
      slug: 'window-cleaning',
      title: 'Мойка окон',
      short: 'Кристально чистые окна внутри и снаружи.',
      intro: 'Прозрачные окна наполняют пространство светом.',
      description: [
        'Профессионально моем окна в квартирах, офисах и коммерческих помещениях — изнутри и снаружи (доступные зоны).',
        'Используем экологичные средства без разводов; стекло чистое, рамы блестят. Регулярная мойка улучшает освещение и внешний вид.'
      ],
      bullets: [
        'Внутренние и доступные внешние стёкла',
        'Протирка рам, подоконников и направляющих',
        'Экологичные средства без разводов',
        'Идеально для дома, офиса и витрин'
      ],
      priceNote: '25 € / час • Минимум 2 часа'
    },
    {
      slug: 'carpet-upholstery-cleaning',
      title: 'Чистка ковров и мебели',
      short: 'Глубокая очистка ковров и мягкой мебели.',
      intro: 'Возвращаем мягкость и устраняем запахи.',
      description: [
        'Удаляем пятна, аллергены и налёт профессиональной техникой под тип ткани, текстиль снова свежий.',
        'Идеально как дополнение к глубокой уборке или самостоятельное обновление для загруженных зон.'
      ],
      bullets: [
        'Экстракция горячей водой или маловлажные методы',
        'Точечное удаление пятен и запахов',
        'Щадящие решения для деликатных тканей',
        'Быстрое высыхание для минимальных простоев'
      ],
      priceNote: 'Цена зависит от ткани и площади'
    }
  ]
};

export default ru;
